import { mapGetters } from 'vuex'
import Add from './add.dialog.vue'
import database from '../../../../api/database'
const columns = [
  {
    title: '',
    enTitle: 'Name',
    width: 150,
    dataIndex: 'name',
    slot: 'html'
  },
  {
    title: '',
    enTitle: 'Image',
    width: 200,
    dataIndex: 'picture',
    slot: 'img'
  },
  {
    title: '',
    enTitle: 'Link',
    width: 200,
    dataIndex: 'linkAddress',
    slot: 'link'
  },
  {
    title: '',
    enTitle: 'Operation Time',
    width: 120,
    dataIndex: 'updateTime',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Status',
    width: 80,
    dataIndex: 'released',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 150,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    Add
  },
  data() {
    return {
      columns,
      isVisable: false,
      dataSource: [],
      params: {
        released: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      user: 'getUser'
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      this.dataSource = await database.getAll(this.params)
    },
    changeStatus(status) {
      this.params.released = status
      this.getList()
    },
    add() {
      this.isVisable = true
    },
    edit(val) {
      this.$refs['database-add'].getQuery(val.id)
      this.isVisable = true
    },
    async able(val) {
      const { id, released, version } = val
      await database.release(id, !released, { version })
      let content = 'This Database has been published!'
      if (released) {
        content = 'This Database has been unpublished!'
      }
      this.$message.success({
        title: 'Success',
        content: content
      })
      this.getList()
    },
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this database?',
        content:
          'Please be aware of once this database is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await database.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This Database has been deleted!'
        })
        this.getList()
      })
    },
    async setSort(val) {
      val.forEach((item, index) => {
        item.sort = index
      })
      await database.setSort(val)
      this.getList()
    },
    confirm() {
      this.getList()
      this.isVisable = false
    },
    cancel() {
      this.isVisable = false
    }
  }
}
